import {Service} from 'typedi';
import {StrategyBuilder} from '../../StrategyBuilder';

import {makeLogger} from '../../../../logger/logger';
import type {HideLabelsStrategyData} from '../../types/hide-labels-strategy-data.type';
import {HideLabelsStrategyService} from '../../HideLabelsStrategyService';

const {err} = makeLogger({pathToCurrentFile: 'components/strategies/services/hide-labels-services/hide-labels-with-terms.service.ts'});

@Service({id: 'hideLabelsWithTermsStrategyService'})
export class FallbackStrategyServiceBuilder extends StrategyBuilder<HideLabelsStrategyService> {

  build(details: HideLabelsStrategyData): HideLabelsStrategyService {
      return new HideLabelsStrategyWithTerms(details);
  }
}

export class HideLabelsStrategyWithTerms extends HideLabelsStrategyService {
  details;

  constructor(details: HideLabelsStrategyData) {
      super();
      this.details = details;
  }

  isHideLabels(term: string):boolean {
      try {
        const hideSearchResultFor = this.details.params?.includes(term);

        if (hideSearchResultFor) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        err('Encountered an unexpected problem while hide labels with terms');
        return false;
      }
  }
}
